import { useState } from 'react';
import RegisterLink from '@/components/ui/RegisterLink';

const BONUSES = [
  {
    id: 'monthlyRanking', icon: 'ri-trophy-line', name: 'Exclusive Monthly Deposit Ranking', tag: 'Competition', tagColor: 'text-orange-400',
    value: '#1 Prize AUD 3,999 · Top 10 Paid', cardAccent: 'rgba(251,146,60,0.1)',
    about: 'Exclusive Monthly Deposit Ranking runs from the 1st to the last day of each month (Sydney/Melbourne time). Ranking is based on total deposit amount only. The more you deposit, the higher you climb. Rewards are distributed after the month ends. Use Check Your Ranking on the promotion to track your position.',
    details: [
      { label: 'Competition Period', value: '1st through last day of each month (Syd/Melb time)' },
      { label: 'Ranking Basis', value: 'Total deposit amount only' },
      { label: 'Rewards', value: 'Distributed after the end of the month' },
      { label: 'Rank #1', value: 'AUD 3,999' },
      { label: 'Rank #2 · #3', value: 'AUD 2,999 · AUD 1,999' },
      { label: 'Rank #4 to #10', value: 'AUD 999 · 599 · 399 · 299 · 199 · 99 · 59' },
    ],
    example: 'Deposit consistently through the month. Climb the leaderboard. Top 10 win fixed cash prizes up to AUD 3,999 for #1',
    steps: ['Log in at Bybid9 during the calendar month (Syd/Melb time)', 'Make deposits. Only total deposit counts toward rank', 'Deposit more to improve your position vs other players', 'Wait for month-end distribution of prizes', 'Open leaderboard / promotion page to check your ranking']
  },
  {
    id: 'birthday', icon: 'ri-cake-3-line', name: 'Birthday Bonus', tag: 'Birthday', tagColor: 'text-pink-400',
    value: 'Claim ±7 Days · Rollover ×10', cardAccent: 'rgba(236,72,153,0.1)',
    about: 'Eligible Bybid9 members can claim a birthday bonus within 7 days before or after their birthday (exact bonus amount is stated on the official promotion). Membership requires a minimum total deposit of AUD 100.00. Play applies to all slot games; Save Free Game is excluded.',
    details: [
      { label: 'Claim Window', value: '7 days before or after your birthday' },
      { label: 'Membership Rule', value: 'Minimum total deposit AUD 100.00 to qualify' },
      { label: 'Games Allowed', value: 'All slot games' },
      { label: 'Excluded', value: 'Save Free Game' },
      { label: 'Withdraw rollover', value: 'Birthday Bonus rollover ×10' },
      { label: 'Min / Max Withdraw', value: 'AUD 50 · AUD 250' },
    ],
    example: 'Meet lifetime deposit threshold. Claim during birthday window. Play eligible slots. Complete ×10 rollover. Withdraw between AUD 50 and AUD 250 per rules',
    steps: ['Ensure your Bybid9 profile meets the minimum total deposit (AUD 100)', 'Contact Live Chat or open the Birthday promo during your ±7 day window', 'Claim the bonus as instructed on site', 'Play all slot games (not Save Free Game)', 'Satisfy rollover ×10 before withdrawal within min/max limits']
  },
  {
    id: 'weeklyCommission', icon: 'ri-percent-line', name: 'Weekly Commission 6%', tag: 'Every Monday', tagColor: 'text-[#47CAF1]',
    value: '6% · Issued Mon 12:00 PM', cardAccent: 'rgba(71,202,241,0.12)',
    about: '6% Weekly Commission is issued automatically every Monday at 12:00 PM to eligible members. It is calculated from total downline deposits minus total downline withdrawals for the week. Listed providers count toward commission; Save Free Game is excluded.',
    details: [
      { label: 'Issuance', value: 'Every Monday 12:00 PM' },
      { label: 'Calculation', value: 'Total deposit minus total withdrawal (all downline, this week)' },
      { label: 'Included Providers', value: 'ACE333, ADVP, BNG2, CQ-1, DGS, FC, LFC, MACROSS, MARIO, PEGS, RG, VP, WOW' },
      { label: 'Excluded', value: 'Save Free Game' },
      { label: 'Withdraw rollover', value: 'Commission rollover ×10' },
      { label: 'Min / Max Withdraw', value: 'AUD 50 · AUD 599' },
    ],
    example: 'Build downline activity across included providers. System totals net deposit weekly. 6% credited Monday 12:00 PM. Complete ×10 rollover. Withdraw AUD 50 to 599 band',
    steps: ['Refer and grow a qualified downline', 'Ensure play uses included providers (not Save Free Game)', 'Wait for Monday 12:00 PM auto credit', 'Track deposit minus withdrawal logic for the week in promotions', 'Meet ×10 rollover then withdraw within min/max']
  },
  {
    id: 'welcome50', icon: 'ri-gift-2-line', name: 'Welcome Bonus 50% (Slots)', tag: 'New Member Once', tagColor: 'text-emerald-400',
    value: 'Min AUD 20 · Up To AUD 250', cardAccent: 'rgba(52,211,153,0.15)',
    about: '50% Welcome Bonus for slots (BNG, JILI and listed providers on promo artwork). New members can claim once only. Minimum deposit AUD 20; maximum bonus up to AUD 250. Save Free Game is excluded. Withdrawal follows Slot Welcome Bonus rollover ×6 with turnover gates.',
    details: [
      { label: 'Claim Limit', value: 'New member once (1) only' },
      { label: 'Minimum Deposit', value: 'AUD 20' },
      { label: 'Maximum Bonus', value: 'Up to AUD 250' },
      { label: 'Providers (promo list)', value: 'ACE333, BNG2, JILI2, ACEWIN, ADVP, BP, BT, CG, CQ9, DGS, FC, JDB, JOKER, KAYA918, LFC, MARIO, PEGS, PGS, PLAYSTAR, RG, VP, WIN38, WOW' },
      { label: 'Excluded', value: 'Save Free Game' },
      { label: 'Withdraw rollover', value: 'Slot Welcome Bonus rollover ×6' },
      { label: 'Min / Max Withdraw (turnover)', value: 'Min ×6 turnover · Max ×100 turnover' },
    ],
    example: 'First deposit AUD 20+ on eligible slots welcome. Get up to 50% capped at AUD 250. Complete ×6 rollover and meet min/max turnover rules before cash-out',
    steps: ['Register and verify as a new member', 'Open the 50% Slot Welcome promotion', 'Deposit at least AUD 20 through the qualifying wallet path', 'Play listed providers only (no Save Free Game)', 'Clear ×6 rollover and satisfy ×6 / ×100 turnover withdrawal rules']
  },
  {
    id: 'weekend30', icon: 'ri-calendar-event-line', name: 'Weekend Deposit 30%', tag: '1× Weekly', tagColor: 'text-amber-400',
    value: 'Min AUD 30 · Up To AUD 288', cardAccent: 'rgba(245,158,11,0.1)',
    about: 'Weekend Deposit 30% can be claimed once per week. Minimum deposit AUD 30; maximum bonus up to AUD 288. Valid on all games except Save Free Game. Weekend Deposit Bonus rollover is ×4; withdrawals use ×3 minimum turnover and ×100 maximum turnover multipliers per promo card.',
    details: [
      { label: 'Claim Frequency', value: '1 time weekly' },
      { label: 'Minimum Deposit', value: 'AUD 30' },
      { label: 'Maximum Bonus', value: 'Up to AUD 288' },
      { label: 'Games', value: 'All games · Save Free Game excluded' },
      { label: 'Withdraw rollover', value: 'Weekend Deposit Bonus rollover ×4' },
      { label: 'Turnover Gates', value: 'Min withdraw ×3 turnover · Max ×100 turnover' },
    ],
    example: 'Deposit AUD 30+ during the weekend promo window once per week. Receive up to AUD 288 bonus. Complete ×4 rollover and turnover gates',
    steps: ['Check weekend promo timing on Bybid9', 'Deposit minimum AUD 30 (once that week)', 'Play all games except Save Free Game', 'Clear ×4 rollover', 'Withdraw respecting ×3 min and ×100 max turnover rules']
  },
  {
    id: 'everyDepositRandom', icon: 'ri-shuffle-line', name: 'Every Deposit Random Bonus', tag: 'Unlimited', tagColor: 'text-cyan-400',
    value: 'AUD 0.1 to 8.88 Random · Min Dep 10', cardAccent: 'rgba(34,211,238,0.1)',
    about: 'Every qualifying deposit can receive a random bonus from AUD 0.1 up to AUD 8.88. Claims are unlimited. Minimum deposit AUD 10. Applies to all games; Save Free Game excluded. Every Deposit Random Bonus rollover ×1; min withdraw requires ×4 turnover, max withdraw ×1 turnover per artwork.',
    details: [
      { label: 'Claim Limit', value: 'Unlimited' },
      { label: 'Minimum Deposit', value: 'AUD 10' },
      { label: 'Bonus Range', value: 'AUD 0.1 to 8.88 (random)' },
      { label: 'Games', value: 'All games · Save Free Game excluded' },
      { label: 'Withdraw rollover', value: 'Every Deposit Random Bonus rollover ×1' },
      { label: 'Turnover Gates', value: 'Min withdraw ×4 turnover · Max ×1 turnover' },
    ],
    example: 'Deposit AUD 10+ anytime. Random credit up to 8.88 AUD. Meet ×1 bonus rollover and turnover row. Withdraw per table',
    steps: ['Deposit at least AUD 10', 'Receive random bonus credited per system', 'Play all games (not Save Free Game)', 'Complete ×1 rollover on the bonus', 'Withdraw using ×4 min / ×1 max turnover conditions shown on promo']
  },
  {
    id: 'referral30', icon: 'ri-share-forward-line', name: 'Referral Bonus 30%', tag: 'Referral', tagColor: 'text-yellow-400',
    value: 'Min AUD 10 To Claim · Max WD AUD 399', cardAccent: 'rgba(250,204,21,0.1)',
    about: 'Refer friends who register via your link. You need a minimum deposit of AUD 10 to claim. Downline first deposit must be AUD 10 or above. Min claim/withdraw AUD 28.00; max withdraw AUD 399. Valid on certain games only; saving free games is prohibited.',
    details: [
      { label: 'To Claim', value: 'Min deposit AUD 10' },
      { label: 'Referral', value: 'Friend registers via your referral link' },
      { label: 'Downline First Deposit', value: 'AUD 10 or above' },
      { label: 'Min Claim / Withdraw', value: 'AUD 28.00' },
      { label: 'Max Withdraw', value: 'AUD 399' },
      { label: 'Games', value: 'Certain games only · Saving free games prohibited' },
    ],
    example: 'Deposit AUD 10+ to unlock claiming. Friend signs up and first-deposits AUD 10+. Earn referral bonus. Withdraw between AUD 28 and AUD 399 on eligible games',
    steps: ['Share your referral link from your Bybid9 account', 'Ensure your own wallet meets AUD 10 deposit to claim', 'Wait for downline first deposit AUD 10 or more', 'Open Referral Bonus 30% and claim per instructions', 'Play only allowed game categories; avoid saving free games']
  },
  {
    id: 'dailyEasy100', icon: 'ri-chat-smile-3-line', name: 'Daily Easy Step Free 100', tag: 'CS & Live Chat', tagColor: 'text-green-400',
    value: 'Hit 1000 Credit · Max WD AUD 20', cardAccent: 'rgba(74,222,128,0.1)',
    about: 'Complete all steps instructed by Customer Service. Contact Live Chat for full details. Event game only. Save Free Game excluded. Hit 1000 credit to unlock withdrawal. AUD 1000 unlocks withdraw path; maximum withdrawal AUD 20 per promo card.',
    details: [
      { label: 'Requirements', value: 'Follow Customer Service instructions' },
      { label: 'More Info', value: 'Contact Live Chat' },
      { label: 'Games', value: 'Event game only · Save Free Game excluded' },
      { label: 'Unlock Condition', value: 'Hit 1000 credit to unlock' },
      { label: 'Hit Amount', value: 'AUD 1000 unlock withdraw' },
      { label: 'Max Withdraw', value: 'AUD 20' },
    ],
    example: 'Complete CS steps for Daily Easy Step. Play event games. Reach 1000 credit unlock. Cash out up to AUD 20 subject to rules',
    steps: ['Open Live Chat and ask for Daily Easy Step Free 100', 'Complete every step Customer Service gives you', 'Play only designated event games', 'Reach the 1000 credit unlock threshold', 'Withdraw up to AUD 20 after AUD 1000 unlock condition']
  },
  {
    id: 'free365', icon: 'ri-calendar-2-line', name: 'FREE 365 Days Bonus', tag: 'Daily', tagColor: 'text-sky-400',
    value: 'AUD 1 to 99 · Once Daily', cardAccent: 'rgba(56,189,248,0.1)',
    about: 'Claim AUD 1 to 99 once per day. Contact Live Chat for more information. Valid on certain games only; Save Free Game is excluded. Hit 100 credits to unlock. AUD 100 unlocks withdraw; maximum withdrawal AUD 30.',
    details: [
      { label: 'Daily Claim', value: 'AUD 1 to 99 once daily' },
      { label: 'More Info', value: 'Contact Live Chat' },
      { label: 'Games', value: 'Certain games only · Save Free Game excluded' },
      { label: 'Unlock Condition', value: 'Hit 100 credit to unlock' },
      { label: 'Hit Amount', value: 'AUD 100 unlock withdraw' },
      { label: 'Max Withdraw', value: 'AUD 30' },
    ],
    example: 'Claim daily random AUD 1 to 99. Play eligible games. Reach 100 credit unlock. Withdraw up to AUD 30 after AUD 100 gate',
    steps: ['Log in daily and claim AUD 1 to 99 per promo rules', 'Ask Live Chat if your game list is eligible', 'Avoid Save Free Game', 'Accumulate to 100 credit unlock', 'Withdraw subject to AUD 100 unlock and AUD 30 max']
  },
  {
    id: 'goldenEgg', icon: 'ri-hammer-line', name: 'Smash the Golden Egg', tag: 'Points Event', tagColor: 'text-violet-400',
    value: 'Deposit $1 = 1 Point', cardAccent: 'rgba(167,139,250,0.12)',
    about: 'Deposit $1 = 1 point. After you submit, the system auto-sends rewards to your wallet within 3 to 10 minutes. Members who do not hit the target are ineligible. Certain games only; Save Free Game excluded. Bronze / Silver / Gold hammers cost 100 / 500 / 1000 points for random egg prizes. Golden Egg Bonus rollover ×2; min withdraw AUD 50; max AUD 999.',
    details: [
      { label: 'Points', value: 'Deposit $1 = 1 point' },
      { label: 'Credit Speed', value: 'Auto to wallet in 3 to 10 minutes after submission' },
      { label: 'Eligibility', value: 'Must hit promotion target, otherwise ineligible' },
      { label: 'Games', value: 'Certain game only · Save Free Game excluded' },
      { label: 'Bronze Hammer (100 pts)', value: 'Random: $0 / $3.88 / $8.88 / $18.88 / $38.88 / $58.88' },
      { label: 'Silver Hammer (500 pts)', value: 'Random: $0 / $28.88 / $58.88 / $108.88 / $208.88 / $308.88' },
      { label: 'Gold Hammer (1000 pts)', value: 'Random: $0 / $88.88 / $188.88 / $588.88 / $688.88 / $888.88' },
      { label: 'Withdraw rollover', value: 'Golden Egg Bonus rollover ×2' },
      { label: 'Min / Max Withdraw', value: 'AUD 50 · AUD 999' },
    ],
    example: 'Earn points from deposits. Exchange for hammer tier. Smash egg for random prize. Meet ×2 rollover. Withdraw AUD 50 to 999',
    steps: ['Deposit to accumulate $1 = 1 point', 'Choose Bronze, Silver, or Gold hammer spend level', 'Submit. Reward arrives in wallet within 3 to 10 minutes', 'Play only allowed games; skip Save Free Game', 'Complete ×2 rollover and withdraw within AUD 50 to 999 limits']
  },
];

export default function BonusSection() {
  const [selected, setSelected] = useState('monthlyRanking');
  const bonus = BONUSES.find((b) => b.id === selected)!;

  return (
    <section className="relative py-14 sm:py-16 md:py-20 px-4 sm:px-5 md:px-8 overflow-hidden" style={{ background: 'linear-gradient(180deg, #0d1117 0%, #091520 50%, #0d1117 100%)' }}>
      <div className="section-divider absolute top-0 left-0 w-full"></div>
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 50% 30%, rgba(71,202,241,0.05) 0%, transparent 60%)' }}></div>

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="badge-blue mb-5"><i className="ri-gift-2-line"></i> Bonus &amp; Promotions Guide</div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-3 px-1">Every Bybid9 Bonus Explained</h2>
          <p className="text-[#56626B] text-base max-w-2xl mx-auto leading-relaxed">Official Bybid9 promotions: monthly ranking, welcome and weekend deposit bonuses, referral, daily events, 365 day rewards, and Golden Egg. Always confirm details on the promotion page every time you login.</p>
        </div>

        {/* Bonus tabs */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3 mb-8 sm:mb-12">
          {BONUSES.map((b) => (
            <button
              key={b.id}
              type="button"
              onClick={() => setSelected(b.id)}
              className="flex flex-col items-center justify-center gap-1.5 sm:gap-2 p-2.5 sm:p-4 rounded-xl sm:rounded-2xl text-center transition-all duration-300 cursor-pointer min-h-[5.25rem] sm:min-h-0 active:opacity-90"
              style={selected === b.id
                ? { background: 'rgba(71,202,241,0.12)', border: '1px solid rgba(71,202,241,0.4)', boxShadow: '0 0 20px rgba(71,202,241,0.15)', transform: 'scale(1.02)' }
                : { background: 'rgba(71,202,241,0.03)', border: '1px solid rgba(71,202,241,0.08)' }
              }
            >
              <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: 'rgba(71,202,241,0.1)', border: '1px solid rgba(71,202,241,0.2)' }}>
                <i className={`${b.icon} text-[#47CAF1] text-base sm:text-lg`}></i>
              </div>
              <span className="text-[9px] sm:text-[10px] font-bold leading-snug line-clamp-2 px-0.5" style={{ color: selected === b.id ? '#47CAF1' : '#56626B' }}>{b.name}</span>
            </button>
          ))}
        </div>

        {/* Detail */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="lg:col-span-2 space-y-4">
            {/* Card */}
            <div className="rounded-2xl p-4 sm:p-6" style={{ background: bonus.cardAccent, border: '1px solid rgba(71,202,241,0.2)' }}>
              <div className="flex items-start justify-between mb-4">
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl flex-shrink-0" style={{ background: 'rgba(71,202,241,0.15)', border: '1px solid rgba(71,202,241,0.3)' }}>
                  <i className={`${bonus.icon} text-[#47CAF1] text-2xl`}></i>
                </div>
                <span className={`px-3 py-1 rounded-full text-[10px] font-bold ${bonus.tagColor}`} style={{ background: 'rgba(255,255,255,0.06)' }}>{bonus.tag}</span>
              </div>
              <h3 className="text-xl font-black text-white mb-1">{bonus.name}</h3>
              <p className="text-[#56626B] text-xs mb-4">{bonus.tag}</p>
              <div className="rounded-xl px-4 py-3 text-center" style={{ background: 'rgba(71,202,241,0.08)', border: '1px solid rgba(71,202,241,0.15)' }}>
                <div className="text-lg font-black text-gradient-blue">{bonus.value}</div>
                <div className="text-[#56626B] text-[10px] mt-0.5">Reward Value</div>
              </div>
            </div>

            {/* Details table */}
            <div className="glass-card rounded-2xl p-5">
              <h4 className="text-white font-bold text-sm mb-4 flex items-center gap-2">
                <i className="ri-table-line text-[#47CAF1]"></i> Bonus Details
              </h4>
              <div className="space-y-2.5">
                {bonus.details.map((d) => (
                  <div key={d.label} className="flex flex-col gap-1 sm:flex-row sm:items-start sm:justify-between sm:gap-3 text-xs pb-3 last:pb-0" style={{ borderBottom: '1px solid rgba(71,202,241,0.06)' }}>
                    <span className="text-[#56626B] font-medium">{d.label}</span>
                    <span className="text-white font-bold sm:text-right break-words">{d.value}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Example */}
            <div className="rounded-2xl p-5" style={{ background: 'rgba(71,202,241,0.05)', border: '1px solid rgba(71,202,241,0.15)' }}>
              <h4 className="text-[#47CAF1] font-bold text-xs mb-2 flex items-center gap-2">
                <i className="ri-calculator-line"></i> Real Example
              </h4>
              <p className="text-white text-xs font-semibold leading-relaxed">{bonus.example}</p>
            </div>
          </div>

          <div className="lg:col-span-3 space-y-5">
            <div className="glass-card rounded-2xl p-5 sm:p-6">
              <h4 className="text-white font-bold text-sm mb-3 flex items-center gap-2">
                <i className="ri-information-line text-[#47CAF1]"></i> About This Bonus
              </h4>
              <p className="text-[#56626B] text-sm leading-relaxed">{bonus.about}</p>
            </div>

            <div className="glass-card rounded-2xl p-5 sm:p-6">
              <h4 className="text-white font-bold text-sm mb-4 flex items-center gap-2">
                <i className="ri-list-ordered-2 text-[#47CAF1]"></i> How to claim, step by step
              </h4>
              <div className="space-y-3">
                {bonus.steps.map((s, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center rounded-full text-[10px] font-black flex-shrink-0 mt-0.5" style={{ background: 'rgba(71,202,241,0.15)', border: '1px solid rgba(71,202,241,0.3)', color: '#47CAF1' }}>{i + 1}</div>
                    <p className="text-[#56626B] text-xs leading-relaxed">{s}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl p-5" style={{ background: 'rgba(250,204,21,0.05)', border: '1px solid rgba(250,204,21,0.15)' }}>
              <h4 className="text-yellow-400 font-bold text-xs mb-2 flex items-center gap-2">
                <i className="ri-file-text-line"></i> Terms &amp; Conditions Summary
              </h4>
              <p className="text-[#56626B] text-xs leading-relaxed">Wagering requirements apply. Bonus funds must be wagered before withdrawal. Check the promotion page every time you login at Bybid9 for complete and up-to-date details.</p>
              <RegisterLink section="bonus" linkLabel="View Full Bonus Terms" href="https://bybid9.tips/promotion" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-yellow-400 text-xs font-bold mt-2 hover:text-yellow-300 transition-colors">
                View Full Bonus Terms at Bybid9 <i className="ri-external-link-line"></i>
              </RegisterLink>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <RegisterLink section="bonus" linkLabel="Claim This Bonus Now" href="https://bybid9.tips/RFLANDINGPAGESEO" className="btn-premium text-sm py-3 flex-1 text-center"><span>Claim This Bonus Now</span></RegisterLink>
              <RegisterLink section="bonus" linkLabel="View All Promotions" href="https://bybid9.tips/RFLANDINGPAGESEO" className="btn-outline-premium text-sm py-3 flex-1 text-center">View All Promotions</RegisterLink>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center">
          <p className="text-[#56626B] text-xs">
            All bonuses are subject to Terms &amp; Conditions. 18+ only. SSL Secured. Gamble responsibly.{' '}
          </p>
        </div>
      </div>
    </section>
  );
}
